import { useEffect, useState } from "react";
import { DownloadSimple, X } from "@phosphor-icons/react";

/* Lightweight PWA install banner. Appears when the browser fires
   `beforeinstallprompt` (Chrome/Edge/Android) and the user hasn't dismissed it. */
export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("pc360-install-dismissed") === "1") return;
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    const onInstalled = () => { setShow(false); setDeferred(null); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setShow(false);
    setDeferred(null);
  };

  const dismiss = () => {
    localStorage.setItem("pc360-install-dismissed", "1");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="pwa-install-banner"
      className="fixed z-[9998] left-4 bottom-4 sm:left-auto sm:right-4 max-w-[340px] glass rounded-2xl border border-white/12 p-4 shadow-2xl"
      style={{ background: "rgba(10,19,17,0.92)", backdropFilter: "blur(16px)" }}
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl flex items-center justify-center shrink-0" style={{ background: "#FFB020" }}>
          <span className="font-display font-extrabold text-lg" style={{ color: "#050B0A" }}>P</span>
        </div>
        <div className="flex-1">
          <div className="text-sm font-semibold text-white">Install PerCen360</div>
          <p className="text-xs text-white/55 mt-0.5 leading-relaxed">Add to your home screen for one-tap access and offline pages.</p>
          <div className="flex items-center gap-2 mt-3">
            <button onClick={install} data-testid="pwa-install-btn" className="btn-gold text-xs px-3 py-1.5">
              <DownloadSimple size={14} weight="bold" /> Install
            </button>
            <button onClick={dismiss} data-testid="pwa-install-dismiss" className="text-xs text-white/45 hover:text-white/80 px-2 py-1.5">
              Not now
            </button>
          </div>
        </div>
        <button onClick={dismiss} aria-label="Dismiss" className="text-white/40 hover:text-white"><X size={16} /></button>
      </div>
    </div>
  );
}
